import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  newCostCentre(event) {
    event.preventDefault();
    const url = this.data.get("url");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".new-cost-centre-form-container").innerHTML =
          html;
        showModal("#new-cost-centre-modal");
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  createCostCentre(event) {
    event.preventDefault();
    const form = this.formTarget;

    axios
      .post(form.action, $(form).serialize())
      .then(response => {
        hideModal("#new-cost-centre-modal");
        $(".account-cost-centres-datatable").DataTable().ajax.reload();
        $(".cost-centres-tab-title").text(
          `Cost Centres (${response.data.count})`
        );
        showNotification(
          "success",
          "The new account cost centre has been created successfully"
        );
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  editCostCentre(event) {
    event.preventDefault();
    const url = this.data.get("url");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".edit-cost-centre-form-container").innerHTML =
          html;
        showModal("#edit-cost-centre-modal");
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  updateCostCentre(event) {
    event.preventDefault();
    const form = this.formTarget;

    axios
      .patch(form.action, $(form).serialize())
      .then(response => {
        hideModal("#edit-cost-centre-modal");
        $(".account-cost-centres-datatable").DataTable().ajax.reload();
        showNotification(
          "success",
          "The account cost centre has been updated successfully"
        );
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  deleteCostCentre(event) {
    event.preventDefault();
    const url = this.data.get("url"),
      description = this.data.get("description"),
      authenticityToken = this.data.get("authenticityToken"),
      controller = this;

    bootbox.confirm({
      title: "Delete Cost Centre",
      message: `Are you sure you want to delete <b>${description}<b>?`,
      callback: function (result) {
        if (result) {
          axios
            .delete(url, { data: { authenticity_token: authenticityToken } })
            .then(response => {
              $(".account-cost-centres-datatable").DataTable().ajax.reload();
              $(".cost-centres-tab-title").text(
                `Cost Centres (${response.data.count})`
              );
              showNotification(
                "success",
                "The account cost centre has been deleted"
              );
            })
            .catch(error => {
              showErrorMessage(error);
            });
        }
      }
    });
  }

  transferServices(event) {
    event.preventDefault();
    const url = this.data.get("url");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".transfer-services-form-container").innerHTML =
          html;
        initializeSelect2Input(
          ".transfer-services-select2",
          "#transfer-services-modal",
          { allowClear: false }
        );
        showModal("#transfer-services-modal");
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  doTransferServices(event) {
    event.preventDefault();
    const form = this.formTarget,
      confirmMsg =
        "Transfer services action cannot be reverted, are you sure you want to continue?";

    hideModal("#transfer-services-modal");

    bootbox.confirm({
      title: "Switch Cost Centre Services",
      message: confirmMsg,
      callback: function (result) {
        if (result) {
          axios
            .patch(form.action, $(form).serialize())
            .then(response => {
              $(".account-cost-centres-datatable").DataTable().ajax.reload();
              showNotification(
                "success",
                "Services has been transferred successfully"
              );
            })
            .catch(error => {
              showErrorMessage(error);
            });
        }
      }
    });
  }

  showCostCentres(event) {
    if (!document.querySelector(".account-cost-centres-datatable.dataTable")) {
      initializeAccountCostCentresDataTable();
    }
  }
}
